import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
      { path: '/studytasks', component: () => import(/* webpackChunkName: "main" */ '../views/studytasks/studytasks.vue'), alias: '/' },
      { path: '/studyTaskDetails', component: () => import(/* webpackChunkName: "main" */ '../views/studytasks/studyTaskDetails.vue') },
      //{ path: '/checkdbs', component: () => import(/* webpackChunkName: "main" */ '../views/checkdbs/checkdbs.vue') },
      { path: '/checktask', component: () => import(/* webpackChunkName: "main" */ '../views/checktask/checktask.vue') },
      { path: '/childaccounts', component: () => import(/* webpackChunkName: "main" */ '../views/accounts/childaccounts.vue') },
      { path: '/teacheraccounts', component: () => import(/* webpackChunkName: "main" */ '../views/accounts/teacheraccounts.vue') },
      { path: '/userInfo', component: () => import(/* webpackChunkName: "main" */ '../views/header/userinfo.vue') },
      { path: '/addmoreteacher', component: () => import(/* webpackChunkName: "main" */ '../views/accounts/addmoreteacher.vue') },
      { path: '/teachergroups', component: () => import(/* webpackChunkName: "main" */ '../views/accounts/teachergroups.vue') },
      { path: '/checkreport', component: () => import(/* webpackChunkName: "main" */ '../views/checkreport/checkreport.vue') },
      //{ path: '/directionalcheck', component: () => import(/* webpackChunkName: "main" */ '../views/checktask/directionalcheck.vue') }
]

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location){
  return originalPush.call(this, location).catch(err => err) 
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
